import React, { useState } from 'react';
import { Box, Typography, Paper, TextField, Alert } from '@mui/material';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import { useAuth } from '../../hooks/useAuth';
import TerminalOrangeButton from '../ui/TerminalOrangeButton';
import {
  dashboardGradientSx,
  terminalColors,
  documentCardSx,
} from '../../theme/terminalStyles';

const Login = () => {
  const { loginUser } = useAuth();
  const [credentials, setCredentials] = useState({ login: '', password: '' });
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleLogin = async () => {
    const loginVal = credentials.login.trim();
    if (!loginVal || !credentials.password) {
      setError('Введіть логін і пароль');
      return;
    }
    setError('');
    setSubmitting(true);
    const ok = await loginUser({ login: loginVal, password: credentials.password });
    setSubmitting(false);
    if (!ok) {
      setError('Невірний логін або пароль');
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') handleLogin();
  };

  return (
    <Box
      sx={{
        ...dashboardGradientSx,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        p: 2,
        boxSizing: 'border-box',
      }}
    >
      <Paper
        elevation={0}
        sx={{
          ...documentCardSx,
          maxWidth: 420,
          width: '100%',
          p: { xs: 3, sm: 4 },
          mb: 0,
          boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
        }}
      >
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mb: 3 }}>
          <Box
            sx={{
              width: 72,
              height: 72,
              borderRadius: 2,
              bgcolor: terminalColors.exitBg,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mb: 2,
            }}
          >
            <LoginOutlinedIcon sx={{ fontSize: 40, color: terminalColors.textPrimary }} />
          </Box>
          <Typography variant="h5" fontWeight={600} color={terminalColors.textPrimary}>
            Вхід у систему
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
            Термінал складу
          </Typography>
        </Box>

        {error ? (
          <Alert severity="error" sx={{ mb: 2 }} onClose={() => setError('')}>
            {error}
          </Alert>
        ) : null}

        <TextField
          label="Логін"
          value={credentials.login}
          onChange={(e) => setCredentials({ ...credentials, login: e.target.value })}
          onKeyDown={onKeyDown}
          fullWidth
          margin="normal"
          variant="outlined"
          autoComplete="username"
          autoFocus
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 1.5,
              bgcolor: '#fff',
            },
          }}
        />
        <TextField
          label="Пароль"
          type="password"
          value={credentials.password}
          onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
          onKeyDown={onKeyDown}
          fullWidth
          margin="normal"
          variant="outlined"
          autoComplete="current-password"
          sx={{
            '& .MuiOutlinedInput-root': {
              borderRadius: 1.5,
              bgcolor: '#fff',
            },
          }}
        />

        <TerminalOrangeButton
          fullWidth
          size="large"
          sx={{ mt: 3, py: 1.5, fontSize: '1.05rem' }}
          onClick={handleLogin}
          disabled={submitting}
        >
          {submitting ? 'Вхід…' : 'Увійти'}
        </TerminalOrangeButton>
      </Paper>
    </Box>
  );
};

export default Login;
